import apiConnector from '@/epersonam/apiConnector';
import errorManager from '@/rollbar.js';

async function init(selector, cf) {
  const button = document.querySelector(selector);

  if (button) {
    button.onclick = async () => {
      try {
        eventBus.$emit('openAdvLoader');
        const result = await apiConnector().get(
          `${window.config.ePersonamService.ePersonamHost}/${window.locale}/cot_discharge_notifications/fse_regionale_url/${cf}`,
          {},
        );
        const fse_redirect_url = result.data;
        window.open(fse_redirect_url, 'target');
        eventBus.$emit('closeAdvLoader');
      } catch (e) {
        eventBus.$emit('closeAdvLoader');
        errorManager(e);
      }
    };
  }
}

window.FascicoloVisualizzatore = {
  init: init,
};
